// extracted by mini-css-extract-plugin
export default {"layoutBackground":"Home_layoutBackground__LKNiZ"};